import React, { useState } from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import BasicButton from 'components/BasicButton';
import BasicButtonGroup from 'components/BasicButtonGroup';
import CheckboxOrRadioGroup from 'components/CheckboxOrRadioGroup';
import Dialog from 'scenes/Dialog';
import Popup from 'components/Popup';
import UxHelpers from 'helpers/ux-helpers.js';
import { ROUTE } from 'constants/route';

const WriteReviewDialog = props => {
  const { show, proceed, dismiss } = props;

  const [reviewType, setReviewType] = useState('Interview Review');

  const dismissHandler = () => {
    dismiss();
    UxHelpers.overflowLock('unlock');
  };

  const onSuccess = () => {
    proceed(addReviewUrl(reviewType));
    UxHelpers.overflowLock('unlock');
  };

  const onReviewTypeChange = e => {
    setReviewType(e.target.value);
  };

  const addReviewUrl = type => {
    switch (type) {
      case 'Interview Review':
        return ROUTE.ADD_REVIEW_INTERVIEW;
      case 'Employee Review':
        return ROUTE.ADD_REVIEW_EMPLOYEE;
      case 'Company Review':
        return ROUTE.ADD_REVIEW_COMPANY;
      default:
        return ROUTE.ADD_REVIEW_COMPANY;
    }
  };

  const buttons = (
    <BasicButtonGroup
      groupStyles={{
        justifyContent: 'center',
        width: '100%',
      }}
    >
      <BasicButton
        controlFunc={onSuccess}
        btnWidth={190}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={`Add ${reviewType}`}
      />
      <BasicButton
        controlFunc={dismissHandler}
        btnWidth={130}
        btnHeight={40}
        btnFontWeight={500}
        btnArrow={false}
        btnTextColor="#27282d"
        btnText={'No Thanks'}
      />
    </BasicButtonGroup>
  );

  const body = (
    <Dialog>
      <div
        style={{ textAlign: 'left', fontWeight: '600', marginBottom: '10px' }}
      >
        Please write one Company, Employee or Interview Review every 12 months
        to receive access to all reviews.
      </div>

      <p style={{ fontWeight: '600', textAlign: 'center' }}>
        Please select review type:
      </p>

      <div
        style={{ margin: '10px 0', display: 'flex', justifyContent: 'center' }}
      >
        <CheckboxOrRadioGroup
          name="reviewType"
          type="radio"
          options={['Interview Review', 'Employee Review', 'Company Review']}
          selectedOptions={reviewType}
          directionRow={false}
          controlFunc={onReviewTypeChange}
        />
      </div>
    </Dialog>
  );

  return (
    show && (
      <Popup
        actions={{
          dismiss,
        }}
        buttonsRender={buttons}
        bodyRender={body}
        popupStyles={{ maxWidth: '480px' }}
      />
    )
  );
};

export default createConfirmation(confirmable(WriteReviewDialog));
